export default __webpack_public_path__ + "static/media/berry-patch.7dc07181.png";